module.exports = __webpack_public_path__ + "static/media/It’s Not Over Yet.985bc014.jpg";